import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { SectionHeading } from "@/components/SectionHeading";
import { WEB_APP_URL, WEB_APP_ENABLED } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export const FAQ = () => {
  const { t } = useLanguage();
  const s = t.faq;
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative scroll-mt-24 py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-6 md:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <SectionHeading index={s.index} eyebrow={s.eyebrow} title={s.title} />
          </div>
        </div>
        <div className="lg:col-span-8">
          <ul className="divide-y divide-[var(--line)] border-y border-[var(--line)]">
            {s.items.map((item, i) => {
              const isOpen = open === i;
              return (
                <li key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`faq-item-${i}`}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="text-lg font-medium text-[var(--ink)] sm:text-xl">{item.q}</span>
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[var(--line-strong)] transition-transform duration-300 ${
                        isOpen ? "rotate-45 bg-[var(--olive)]/20 border-[var(--sage)]/50" : ""
                      }`}
                    >
                      <Plus className="h-4 w-4 text-[var(--sage)]" />
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.2, 0.7, 0.2, 1] }}
                        className="overflow-hidden"
                      >
                        <div className="max-w-2xl pb-7">
                          <p className="text-base leading-relaxed text-[var(--ink-2)]">{item.a}</p>
                          {item.link && (item.link.href !== "web" || WEB_APP_ENABLED) && (
                            <a
                              href={item.link.href === "web" ? WEB_APP_URL : item.link.href}
                              target={item.link.href === "web" ? "_blank" : undefined}
                              rel="noopener noreferrer"
                              className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[var(--sage)] hover:text-white"
                              data-testid={`faq-link-${i}`}
                            >
                              {item.link.label}
                              <ArrowUpRight className="h-4 w-4" />
                            </a>
                          )}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};
